<!-- components/forbidden-keyword-filter.vue -->
<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="keywordFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#keywordFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="keyword">
                                                {{ $t('label.wallet_settlement_blacklist.forbidden_sheba_title') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="keyword"
                                                name="keyword"
                                                id="keyword"
                                                v-model="query.keyword"
                                                :placeholder="$t('label.wallet_settlement_blacklist.forbidden_sheba_placeholder')"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('label.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    type="button"
                                                    class="btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD 00:00:00"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                id="from_date"
                                                name="from_date"
                                                v-model="query.from_date"
                                                type="date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('label.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    type="button"
                                                    class="btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD 23:59:59"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                id="to_date"
                                                name="to_date"
                                                v-model="query.to_date"
                                                type="date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="1" style="margin-top: 26px">
                                        <kt-form-section>
                                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                        </kt-form-section>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
import {i18n} from '@/plugins/i18n'

export default {
    props: {
        action: {
            default: function (e, query) {
            },
            required: true,
        }
    },
    data() {
        return {
            query: {
                keyword: '',
                status: '',
                from_date: null,
                to_date: null
            },
        }
    },
    methods: {
        clearFromDate() {
            if(this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if(this.query.to_date) {
                this.query.to_date = null
            }
        },
        clearFilters() {
            this.query = {
                keyword: '',
                status: '',
                from_date: null,
                to_date: null
            }
            this.action(null, this.query)
        }
    }
}
</script>